import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Env } from '@contexts/AppContext';
import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { Event } from '@utils/backend-api/events';

import FutureEvents from './FutureEvents';
import GetInTouch from './GetInTouch';
import Glance from './Glance';
import GlanceSlideshow from './GlanceSlideshow';
import MomentThatMatter from './MomentThatMatter';
import PastEvents from './PastEvents';
import PastSpeakers from './PastSpeakers';
import Patners from './Patners';
import SlideShow from './SlideShow';
import Testimonials from './Testimonials';

const queryClient = new QueryClient();

interface EventsLandingProps {
  env: Env;
  eventEntityId: number;
  followStatus: boolean;
  futureEvents?: Event[];
  initialCurrentUser: User;
  isCurrentUserSubscriber: boolean;
  isGdprRequired: boolean;
  isWebview: boolean;
}

const EventsLanding = ({
  env,
  eventEntityId,
  followStatus,
  futureEvents,
  initialCurrentUser,
  isCurrentUserSubscriber,
  isGdprRequired,
  isWebview,
}: EventsLandingProps) => {
  const { Track } = useEventTracking({
    page: Page.EventsLandingPage,
  });
  return (
    <Track>
      <AppContextProvider
        env={env}
        isGdprRequired={isGdprRequired}
        isWebview={isWebview}
        initialCurrentUser={initialCurrentUser}
      >
        <QueryClientProvider client={queryClient}>
          <SlideShow
            followStatus={followStatus}
            eventEntityId={eventEntityId}
            queryClient={queryClient}
            isCurrentUserSubscriber={isCurrentUserSubscriber}
          />
          {futureEvents && <FutureEvents futureEvents={futureEvents} />}
          <PastEvents />
          <Glance />
          <GlanceSlideshow />
          <PastSpeakers />
          <MomentThatMatter />
          <Patners />
          <Testimonials />
          <GetInTouch />
        </QueryClientProvider>
      </AppContextProvider>
    </Track>
  );
};

export default EventsLanding;
